import axios from 'axios';

type ApiErrorResponse = {
  message?: string;
  error?: string;
  errors?: Array<{ message?: string }>;
};

export const extractApiErrorMessage = (
  error: unknown,
  fallback = 'Something went wrong. Please try again.'
): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ApiErrorResponse | undefined;

    if (typeof data?.message === 'string' && data.message.trim()) {
      return data.message;
    }

    if (typeof data?.error === 'string' && data.error.trim()) {
      return data.error;
    }

    const firstNestedMessage = data?.errors?.find((entry) => entry?.message)?.message;
    if (typeof firstNestedMessage === 'string' && firstNestedMessage.trim()) {
      return firstNestedMessage;
    }

    if (typeof error.message === 'string' && error.message.trim()) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
